// // sub.jsファイルを読み込む
// import {hello} from "./sub";
// // sub.jsに定義されたJavaScriptを実行する
// hello();

// import {BREAKPOINTS} from "./breakpoints";

// lib
import $ from 'jquery';

// modules
import Common from './common';
import CommunityPage from './communityPage';
import SingleSpace from './singleSpace';
import FrontPage from './frontPage';
import ContactPage from './contactPage';
import ImageModal from './imageModal';

// Sass/cssファイルの読み込み
import "animate.css";
import "sticky-state/dist/sticky-state.css"
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'normalize.css';
import "../sass/style.scss";

$(function(){
   new Common();
   new CommunityPage();
   new SingleSpace();
   new FrontPage();
   new ContactPage();
   new ImageModal();
});

